function setupEuplatesc() {
  $(".js-donate-next").click(function(ev) {
    var eyelevel = $(".donation-container").offset().top;
    var windowlevel = $(window).scrollTop();
    if (windowlevel > eyelevel) {
      $("html, body").animate({scrollTop: eyelevel}, 1000);
    }
    return true;
  });

  $(".js-donate").click(function(ev) {
    ev.preventDefault();

    var post_form = function(data, status) {
      var form = document.createElement('form');
      form.action = "https://secure.euplatesc.ro/tdsprocess/tranzactd.php"
      form.method = "post";
      form.accept = "application/json";
      form.id = "euplatesc-pay-form";

      $.each(data.form, function(k,v) {
        if (v !== null) {
          var field = document.createElement('input');
          field.type = 'hidden';
          field.name = k;
          field.value = v;
          form.appendChild(field);
        }
      });
      document.querySelector('#donate-form-container-id').appendChild(form);

      form.submit();
    };

    var form = $(ev.target).closest("form");
    if (form.checkValidity()) {
      $.post(form.attr('action'), form.serialize(), post_form, 'json');
    } else {
      return false;
    }
  });
}


/*** EXPORTS FROM exports-loader ***/
module.exports = setupEuplatesc;